import { render, staticRenderFns } from "./ThemeElementTabs.vue?vue&type=template&id=36c62050&"
import script from "./ThemeElementTabs.vue?vue&type=script&lang=js&"
export * from "./ThemeElementTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports